import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import BannerElement from "@jumbo/Dashboards/Banner/BannerElement";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.bannersPage"} />, link: "/banners" },
  { label: <IntlMessages id={"pages.createBanner"} />, isActive: true },
];

const CreateBanner = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.createBanner" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <BannerElement />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default CreateBanner;
